<div class="filters_list">
    <p class="title">{{ label }}</p>
    <div class="row">

        <ng-content select="[beforeOptions]"></ng-content>

        <div class="col_12 option_full" *ngFor="let parentOption of displayedParentOptions; index as parentIndex">
            <div class="option no_padding" [ngClass]="isSelectedItem(parentOption) ? 'selected' : ''">
                <input type="checkbox" id="{{ key }}-{{ parentIndex }}" [checked]="isSelectedItem(parentOption)" (click)="handleParentSelection(parentOption)">
                <label for="{{ key }}-{{ parentIndex }}">{{ getLabelPropertyValue(parentOption) }}</label>
            </div>

            <div *ngFor="let childOption of retrieveChildOptionsFromParentOption(parentOption); index as childIndex" class="option no_padding child" [ngClass]="isSelectedItem(childOption) ? 'selected' : ''">
                <input type="checkbox" id="{{ key }}-{{ parentIndex }}-{{ childIndex }}" [checked]="isSelectedItem(childOption)" (click)="handleChildSelection(childOption, parentOption)">
                <label for="{{ key }}-{{ parentIndex }}-{{ childIndex }}">{{ getLabelPropertyValue(childOption) }}</label>
            </div>
        </div>
    </div>
    <ng-container *ngIf="displayToggleParentOptionsAction">
        <button type="button" class="more_option icon-tywin-chevron" (click)="toggleParentOptionDisplay()" [ngClass]="allParentOptionsDisplayed ? 'open': ''">
            {{ (allParentOptionsDisplayed ? 'option.plural.display.less.value' : 'option.plural.display.more.value') | translate }}
        </button>
    </ng-container>
</div>
